module.exports = __webpack_public_path__ + "assets/lawandorder-2.87c72462.svg";